import ErrorCode from "../enums/ErrorCode";

class UnProcessableEntityException extends Error {

    constructor(response) {
        var result = JSON.parse(response.data);

        super(result.message);

        this.errors = result.errors;
        this.name = this.constructor.name
        this.message = result.message
        this.errorCode = ErrorCode.UnprocessableEntity;
    }
}

export default UnProcessableEntityException;